import { WSElement, WSElementProps } from "@wingspanhq/fe-component-library";
import { OtpVerificationChannel } from "@wingspanhq/users/dist/lib/interfaces";
import React, { useState } from "react";
import { EmailSent } from "./EmailSent";
import { OtpRequestForm } from "./OtpRequestForm";
import { SmsConfirmationForm } from "./SmsConfirmationForm";

type Props = {
  onSuccess: () => void;
  onClose: () => void;
  apiPath?: string;
} & WSElementProps;

export const ModalOtpVerification: React.FC<Props> = ({
  onSuccess,
  onClose,
  apiPath,
  ...elementProps
}) => {
  const [selectedChannel, setSelectedChannel] = useState<
    OtpVerificationChannel | undefined
  >();

  const prefferPhone =
    apiPath?.includes("/payout-settings") ||
    apiPath?.includes("/v2/banking/internal-accounts");

  return (
    <WSElement {...elementProps}>
      {selectedChannel && selectedChannel === OtpVerificationChannel.Email ? (
        <EmailSent />
      ) : selectedChannel && selectedChannel === OtpVerificationChannel.SMS ? (
        <SmsConfirmationForm
          onSuccess={() => {
            onSuccess();
            onClose();
          }}
        />
      ) : (
        <OtpRequestForm
          prefferPhone={prefferPhone}
          onSuccess={({ channel }) => {
            setSelectedChannel(channel);
          }}
        />
      )}
    </WSElement>
  );
};
